import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { useTranslationContext } from '../context/TranslationContext';

type SectionProps = {
  title: string;
  children: ReactNode;
  enableDirectionSearch?: boolean;
  onDirectionSearchClick?: () => void;
  action?: ReactNode;
};

const Section = ({
  title,
  children,
  enableDirectionSearch = false,
  onDirectionSearchClick,
  action,
}: SectionProps) => {
  const t = useTranslationContext();
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        mb: 2,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1">{title}</Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          {action}
          {enableDirectionSearch && (
            <Button
              startIcon={
                <AddLocationAltIcon sx={{ color: 'primary.main', height: 18, width: 18 }} />
              }
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => onDirectionSearchClick && onDirectionSearchClick()}
            >
              {t('global.searchLocation')}
            </Button>
          )}
        </Stack>
      </Stack>
      <Divider sx={{ my: 1.5 }} />
      {children}
    </Box>
  );
};

export default Section;
